<template>
  <footer>
    <Grid>
      <div class="grid-column x4 smallprint">
        <Logo />
        <div class="content txt">
          <p>
            <a href="/static/imprint.txt" class="link">Imprint</a>

            <br />
            Copyright {{ year }} - No Tracking
            <br />
          </p>
          <p>
            <strong>
              Enjoy the rest of your
              <br />
              {{ day }}!
            </strong>
          </p>
        </div>
      </div>
    </Grid>
  </footer>
</template>
<script>
import Grid from "./Grid.vue";
import Logo from "./Logo.vue";
export default {
  name: "Footer",
  components: {
    Grid,
    Logo
  },
  data() {
    return {
      day: "Geburtstag",
      year: 1983
    };
  },
  methods: {
    getYear() {
      this.year = new Date().getFullYear();
    },
    getDay() {
      let weekday = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ];

      this.day = weekday[new Date().getDay()];
    }
  },
  mounted() {
    this.getDay();
    this.getYear();
  }
};
</script>
<style scoped>
footer {
  min-height: calc(50vh - var(--LINE-HEIGHT) * 4);
  margin-bottom: calc(var(--LINE-HEIGHT) * 4);
}
@media only screen and (max-width: 576px) {
  footer {
    min-height: calc(50 * var(--vh) - var(--LINE-HEIGHT) * 4);
  }
}

footer .logo {
  height: calc(var(--LINE-HEIGHT) * 2);
  margin-left: var(--EXTRA-SPACE-LEFT);
}

@media only screen and (max-width: 576px) {
  footer .logo {
    position: absolute;
    bottom: 0;
    right: 0;
  }
} /*
@media only screen and (min-width: 576px) and (max-width: 767px) {}
@media only screen and (min-width: 768px) and (max-width: 992px) {}
@media only screen and (min-width: 992px) {}
*/

footer .grid {
  min-height: calc(50vh - var(--LINE-HEIGHT) * 4);
}
@media only screen and (max-width: 576px) {
  footer .grid {
    min-height: calc(50vh - var(--LINE-HEIGHT) * 4);
  }
}

.smallprint {
  align-self: flex-end;
  margin-bottom: calc(var(--LINE-HEIGHT) * 2);
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue